import React from 'react';

import { Input, Dropdown, Toggle } from '@components';

type ColumnTypeOption = OptionType<DynamicColumnTypeEnum>;

const COLUMN_TYPE_OPTIONS: ColumnTypeOption[] = [
  { label: 'Text', value: 'text' },
  { label: 'Phone', value: 'phone' },
  { label: 'Date', value: 'date' },
  { label: 'Enum', value: 'enum' },
  { label: 'Boolean', value: 'boolean' },
  { label: 'Composite', value: 'composite' },
];

type ColumnBasicFieldsProps = {
  column: DynamicColumnType;
  onUpdate: (updates: Partial<DynamicColumnType>) => void;
};

const ColumnBasicFields: React.FC<ColumnBasicFieldsProps> = ({
  column,
  onUpdate,
}) => {
  return (
    <div className="flex flex-col gap-y-lg">
      <div className="flex flex-row gap-md">
        <div className="flex-1">
          <label className="text-small text-textLight font-normal mb-xs block">
            Key *
          </label>
          <Input
            value={column.key}
            onChange={val => onUpdate({ key: val.trim() })}
            placeholder="column_key"
            withBorder
          />
        </div>
        <div className="flex-1">
          <label className="text-small text-textLight font-normal mb-xs block">
            Label *
          </label>
          <Input
            value={column.label}
            onChange={val => onUpdate({ label: val })}
            placeholder="Column Label"
            withBorder
          />
        </div>
      </div>

      <div className="flex flex-row gap-md">
        <div className="flex-1">
          <label className="text-small text-textLight font-normal mb-xs block">
            Type
          </label>
          <Dropdown
            value={column.type || 'text'}
            options={COLUMN_TYPE_OPTIONS}
            onChange={type => onUpdate({ type })}
          />
        </div>
        <div className="flex-1">
          <label className="text-small text-textLight font-normal mb-xs block">
            Width
          </label>
          <Input
            withBorder
            placeholder="100px, 20%"
            value={column.width || ''}
            onChange={val => onUpdate({ width: val || null })}
          />
        </div>
      </div>

      <div className="flex flex-row gap-md">
        <div className="flex-1">
          <label className="text-small text-textLight font-normal mb-xs block">
            Sort Key
          </label>
          <Input
            value={column.sort_key || ''}
            onChange={val => onUpdate({ sort_key: val || null })}
            placeholder="sort_key"
            withBorder
          />
        </div>
        <div className="flex-1">
          <label className="text-small text-textLight font-normal mb-xs block">
            Null Label
          </label>
          <Input
            value={column.null_label || ''}
            onChange={val => onUpdate({ null_label: val || null })}
            placeholder="N/A"
            withBorder
          />
        </div>
      </div>

      <div className="flex flex-row gap-md">
        <label className="flex items-center gap-md cursor-pointer">
          <Toggle
            value={column.sortable || false}
            onChange={sortable => onUpdate({ sortable })}
          />
          <span className="text-small text-textLight font-normal">
            Sortable
          </span>
        </label>
        <label className="flex items-center gap-md cursor-pointer">
          <Toggle
            value={column.filterable || false}
            onChange={filterable => onUpdate({ filterable })}
          />
          <span className="text-small text-textLight font-normal">
            Filterable
          </span>
        </label>
      </div>
    </div>
  );
};

export default ColumnBasicFields;
